import { Dropdown, Icon, IconButton, TextField } from '@monash/portal-react';
import c from './link-url-inputs.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { formatUrl, isUrl } from '@monash/portal-frontend-common';
import InlineErrorMessage from '../../../../common/inline-error-message/InlineErrorMessage';
import { LINK_TEXT_OPTIONS, LINKS_INLINE_ERROR_MSGS } from '../../constants';

const LinkUrlInputs = ({ index, removeLinkUrl, disabled, canRemove }) => {
  const {
    trigger,
    formState: { errors, isSubmitted },
  } = useFormContext();

  const namePrefix = `links.${index}`;
  const textFieldName = `${namePrefix}.text`;
  const urlFieldName = `${namePrefix}.url`;

  const getError = () => {
    const linkErrors = errors.links?.[index];
    const textError = linkErrors?.text;
    const urlError = linkErrors?.url;

    if (textError) return [textError, textError.message];
    if (urlError) return [urlError, urlError.message];
    return [null, null];
  };

  const [linkError, linkErrorMsg] = getError();

  return (
    <>
      <Controller
        name={textFieldName}
        render={({ field: { value, onChange, onBlur } }) => (
          <Dropdown
            data={LINK_TEXT_OPTIONS}
            value={value}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              isSubmitted && trigger(textFieldName); // Manually validate b/c dropdown's onBlur doesn't validate on first blur
            }}
            disabled={disabled}
          />
        )}
      />
      <Controller
        name={urlFieldName}
        rules={{
          validate: (value) => {
            const formattedUrl = formatUrl(value);
            if (!isUrl(formattedUrl)) return LINKS_INLINE_ERROR_MSGS.URL;
          },
        }}
        render={({ field: { value, onChange, onBlur } }) => (
          <TextField
            placeholder="https://www.monash.edu"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
          />
        )}
      />
      <div className={c.deleteButtonContainer}>
        <IconButton
          icon={Icon.X}
          color="var(--card-text-color)"
          onClick={removeLinkUrl}
          aria-label="Delete link"
          disabled={disabled || !canRemove}
        />
      </div>
      {linkError && (
        <InlineErrorMessage className={c.error} message={linkErrorMsg} />
      )}
    </>
  );
};

export default LinkUrlInputs;
